import type { Traducao } from '../textos.ts'

/** Rótulos do invólucro; conteúdo e títulos próprios das páginas continuam na origem. */
export const TEXTOS_DA_SOBREPOSICAO = {
  ler: { 'pt-BR': 'Como ler esta página', 'es-419': 'Cómo leer esta página', 'en-US': 'How to read this page' },
  ajuda: { 'pt-BR': 'Central de ajuda', 'es-419': 'Centro de ayuda', 'en-US': 'Help center' },
  fechar: { 'pt-BR': 'Fechar', 'es-419': 'Cerrar', 'en-US': 'Close' },
} satisfies Readonly<Record<string, Traducao>>
